import { Box, styled, Tooltip } from '@mui/material'
import { useAlerts } from '@app/lib/packages'
import { themeColors } from '@app/constants'
import { useTranslation } from '@app/lib/lang'

interface CopyableFieldProps {
	value: string | undefined | null
	label: string | undefined | null
	children?: React.ReactNode
}

const CopyableWrapper = styled(Box)(({ theme }) => ({
	cursor: 'pointer',
	transition: 'all 0.2s ease',
	padding: '2px 6px',
	margin: '-2px -6px',
	borderRadius: '4px',
	display: 'inline-block',
	width: 'fit-content',
	'&:hover': {
		backgroundColor: themeColors.warmGrey,
	},
}))

export default function CopyableField({
	value,
	label,
	children,
}: CopyableFieldProps) {
	const { addSuccessAlert } = useAlerts()
	const { t } = useTranslation()

	const handleCopy = async () => {
		if (!value) return

		try {
			await navigator.clipboard.writeText(value)
			addSuccessAlert('shared.copiedToClipboard', {
				field: t(label ?? ''),
			})
		} catch (err) {
			console.error('Failed to copy:', err)
		}
	}

	return (
		<Tooltip title="Click to copy" arrow>
			<CopyableWrapper onClick={handleCopy}>{children}</CopyableWrapper>
		</Tooltip>
	)
}
